"use client";

import { NavigationBarLayout } from "~care/components/app/landing/Navigation";
import PhoneLink from "~care/components/app/landing/PhoneLink/PhoneLink";
import ContactIcon from "~care/components/ui/Icons/ui/contact-icon.svg";
import { INVOCA_PHONE_NUMBER } from "~care/lib/constants/phone-numbers";
import { formatPartialPhoneNumber } from "~care/lib/utils/phone/phone";
import { NavigationPhoneCTA } from "./NavigationPhoneCTA";
import { shallowStrings } from "./navigation-strings";

interface ShallowDesktopCTAProps {
  phoneNumber: string;
  formattedPhoneNumber: string;
}

export function ShallowDesktopCTA({
  phoneNumber,
  formattedPhoneNumber,
}: ShallowDesktopCTAProps) {
  return (
    <div className="me-6 flex h-12 items-center gap-3 xl:me-0">
      <ContactIcon className="min-w-6" />
      <div>
        <span>{shallowStrings.openCallUsNow} &nbsp;</span>
        <PhoneLink
          className="inline-block h-fit p-0"
          phoneNumber={phoneNumber}
          placement="header"
          variant={"plain"}
        >
          {formattedPhoneNumber}
        </PhoneLink>
      </div>
    </div>
  );
}

interface ShallowMobileCTAProps {
  phoneNumber: string;
  formattedPhoneNumber: string;
}

export function ShallowMobileCTA({
  phoneNumber,
  formattedPhoneNumber,
}: ShallowMobileCTAProps) {
  return (
    <div className="me-5 flex h-12 items-center gap-3 xl:me-0">
      <NavigationPhoneCTA
        formattedPhoneNumber={formattedPhoneNumber}
        phoneNumber={phoneNumber}
      />
    </div>
  );
}

interface NavigationShallowProps {
  containerClassName?: string;
  phoneNumber?: string;
}

export default function NavigationShallow({
  containerClassName,
  phoneNumber = INVOCA_PHONE_NUMBER,
}: NavigationShallowProps) {
  const formattedPhoneNumber = formatPartialPhoneNumber({
    franchisePhone: phoneNumber,
  });

  return (
    <NavigationBarLayout
      containerClassName={containerClassName}
      desktopCTA={
        <ShallowDesktopCTA
          formattedPhoneNumber={formattedPhoneNumber}
          phoneNumber={phoneNumber}
        />
      }
      mobileCTA={
        <ShallowMobileCTA
          formattedPhoneNumber={formattedPhoneNumber}
          phoneNumber={phoneNumber}
        />
      }
    />
  );
}
